
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_fvjdu_fz9xm_93",
  "button": "awsui_button_fvjdu_fz9xm_135",
  "dots": "awsui_dots_fvjdu_fz9xm_136",
  "button-disabled": "awsui_button-disabled_fvjdu_fz9xm_158",
  "arrow": "awsui_arrow_fvjdu_fz9xm_163",
  "page-number": "awsui_page-number_fvjdu_fz9xm_173",
  "button-current": "awsui_button-current_fvjdu_fz9xm_179",
  "page-item": "awsui_page-item_fvjdu_fz9xm_196",
  "root-disabled": "awsui_root-disabled_fvjdu_fz9xm_212"
};
  